/**
 * Powers fields backed by the NamedUrlView and NamedUrlListView classes
 *
 * @author (MattJS) matt@yext.com
 */
goog.provide('yext.location.NamedUrl');
goog.provide('yext.location.NamedUrlList');
goog.require('yext');
goog.require('yext.textutil.CharacterCounter');
goog.require('yext.location.helpers');
goog.require('yext.textfield');

/**
 * A list of NamedUrls. Ex. Rank Tracking Competitors
 * @constructor
 * @param {!jQuery} $ctx
 */
yext.location.NamedUrlList = function($ctx) {
  this.$ctx = $ctx;
  this.$listItems = $ctx.find('.js-named-url-list-items');
  this.$template = $($ctx.find('.js-named-url-template').html());
  this.$fieldValue = $ctx.find('.js-field-value');

  this.urls = [];
  this.timestamp = $ctx.data('timestamp');
  this.maxItemCount = parseInt($ctx.data('maxItemCount'));

  this.bindings();
  this.saveState();
  this.setFieldValue();
};

/**
 * Initialize text fields and other bindings
 */
yext.location.NamedUrlList.prototype.bindings = function() {
  var self = this;

  this.$listItems.find('.js-named-url').each(function() {
    self.newUrl($(this));
  });

  this.$ctx.find('.js-add-item').click(function() {
    var $item = self.$template.clone();
    self.newUrl($item);
    self.$listItems.append($item);
    self.message('updated');
  });

  this.$listItems.on('click', '.js-remove-item', function() {
    var url = $(this).closest('.js-named-url').data('url');
    var index = self.urls.indexOf(url);
    if (index !== -1) {
      self.urls.splice(index, 1);
      url.$ctx.remove();
    }
    self.message('updated');
  });

  $(this).on('updated', function() {
    self.setFieldValue();
    self.render();
  });
};

/**
 * Any field wide rendering outside should be done here
 */
yext.location.NamedUrlList.prototype.render = function() {
  this.$ctx.find('.js-add-item').toggle(this.urls.length < this.maxItemCount);
};

/**
 * @param {!jQuery} $item
 * @return {yext.location.NamedUrl}
 */
yext.location.NamedUrlList.prototype.newUrl = function($item) {
  var self = this;
  var namedUrl = new yext.location.NamedUrl($item);

  $item.data('url', namedUrl);
  this.urls.push(namedUrl);

  $(namedUrl).on('updated', function() {
    self.message('updated');
  });

  return namedUrl;
};

/**
 * Returns display mode as human readable text/html
 *
 * @return {string}
 */
yext.location.NamedUrlList.prototype.getDisplayValue = function() {
  var values = [];
  var hasIndeterminate = false;

  for (var i = 0; i < this.urls.length; i++) {
    var url = this.urls[i];
    if (url.indeterminate) {
      hasIndeterminate = true;
      break;
    }
    values.push(url.name.value() + ' (' + url.url.value() + ')');
  }

  if (hasIndeterminate) {
    return yext.location.helpers.variousContentMessage();
  } else if (values.length) {
    return '<ul><li>' + values.join('</li><li>') + '</li></ul>';
  } else {
    return yext.location.helpers.emptyFieldMessage();
  }
};

/**
 * Sets a hidden input to the value of the field as JSON
 */
yext.location.NamedUrlList.prototype.setFieldValue = function() {
  this.$fieldValue.val(window.JSON.stringify(this.getData()));
};

/**
 * Broadcast a message with the instance as context
 * @param {string} message
 */
yext.location.NamedUrlList.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * Save the current state of the field
 */
yext.location.NamedUrlList.prototype.saveState = function() {
  this.urls.forEach(function(url) {
    url.saveState();
  });
  this.storedUrls = this.urls.slice();
};

/**
 * Reset the state of the field
 */
yext.location.NamedUrlList.prototype.reset = function() {
  var self = this;
  var data = [];

  // Gather stored urls as simple data
  this.storedUrls.forEach(function(url) {
    url.reset();
    data.push(url.data());
    url.destroy();
  });

  // Clean up any new urls
  this.urls.forEach(function(url) {
    url.destroy();
  });

  this.set({
    'urls': data,
  });
};

/**
 * Returns a POJO version of the data for this field
 *
 * @return {!Object}
 */
yext.location.NamedUrlList.prototype.getData = function() {
  var data = [];
  this.urls.forEach(function(url) {
    if (url.isSelected()) {
      data.push(url.data());
    }
  });

  return {
    'urls': data,
    'timestamp': this.timestamp,
  };
};

/**
 * This method wipes out the current UI and reconstructs it using the data provided
 *
 * @param {!Object} field
 */
yext.location.NamedUrlList.prototype.set = function(field) {
  this.$listItems.empty();
  this.urls = [];

  for (var i = 0; i < field['urls'].length; i++) {
    var $item = this.$template.clone();
    var url = this.newUrl($item);
    this.$listItems.append($item);
    url.set(field['urls'][i]);
  }
  this.message('updated');

  if (field['timestamp']) {
    this.timestamp = field['timestamp'];
  }
};

/**
 * Adds an empty item to urls
 */
yext.location.NamedUrlList.prototype.addEmptyItem = function() {
  var $item = this.$template.clone();
  var url = this.newUrl($item);
  this.$listItems.append($item);
};

/**
 * Returns true if urls is empty
 */
yext.location.NamedUrlList.prototype.isEmpty = function() {
  return this.urls.length === 0;
};

/**
 * @constructor
 * @param {!jQuery} $ctx
 */
yext.location.NamedUrl = function($ctx) {
  this.$ctx = $ctx;
  this.$checkbox = $ctx.find('input[type=checkbox]');
  this.fieldId = $ctx.find('.js-named-url-wrap').data('fieldId');

  this.name = yext.textfield.createWithUsageType($ctx.find('.js-url-name .js-text-field'), this.fieldId);
  this.url = yext.textfield.createWithUsageType($ctx.find('.js-url-value .js-text-field'), this.fieldId);
  this.indeterminate = !!this.$checkbox.data('indeterminate');
  this.$nameInput = $ctx.find('.js-url-name');
  this.$fieldValue = $ctx.find('.js-field-value');
  this.timestamp = $ctx.data('timestamp');

  this.addCharacterCounter();
  this.setFieldValue();
  this.bindings();
  this.render();
};

/**
 * add Character Counter
 */
yext.location.NamedUrl.prototype.addCharacterCounter = function() {
  if (this.$nameInput.data('limit')) {
    this.charCounter = new yext.textutil.CharacterCounter(this.$nameInput.find('.js-text-field-input'), {
      limit: this.$nameInput.data('limit'),
      onFocus: false,
    });
  }
};

/**
 * @return {boolean} True if selected (bulk mode)
 */
yext.location.NamedUrl.prototype.isSelected = function() {
  return this.indeterminate || this.$checkbox.prop('checked');
};

/**
 * Connect up update events and bind checkbox
 */
yext.location.NamedUrl.prototype.bindings = function() {
  var self = this;

  $(this.name).on('update.textField', function() {
    self.onUpdate();
  });

  $(this.url).on('update.textField', function() {
    self.onUpdate();
  });

  this.$checkbox.on('click', function() {
    if (self.indeterminate) {
      // Always transition indeterminate to checked
      self.$checkbox.prop('checked', true);
    }
    self.indeterminate = false;
    self.render();
    self.message('updated');
  });
};

yext.location.NamedUrl.prototype.onUpdate = function() {
  this.setFieldValue();
  this.message('updated');
};

/**
 * Generates the display mode for the field
 *
 * @return {string} Html string
 */
yext.location.NamedUrl.prototype.getDisplayValue = function() {
  if (this.name.displayValue()) {
    var $markup = this.name.viewMarkup();
    if (yext.isValidUrl(this.url.value())) {
      $markup = this.createLink($markup);
    }
    return $markup;
  } else {
    return yext.location.helpers.emptyFieldMessage();
  }
};

/**
 * Create the link for url
 *
 * @param content
 */
yext.location.NamedUrl.prototype.createLink = function(content) {
  return $('<a>').attr({
    'href': yext.location.helpers.preprendProtocol(this.url.value()),
    'class': 'no-edit',
    'target': '_blank',
  }).html(content);
};

/**
 * Clean up to avoid any memory leaks
 */
yext.location.NamedUrl.prototype.destroy = function() {
  this.name.destroy();
  this.url.destroy();
};

/**
 * Broadcast a message with the instance as context
 * @param {string} message
 */
yext.location.NamedUrl.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * Save the current state of this field
 */
yext.location.NamedUrl.prototype.saveState = function() {
  this.name.saveValue();
  this.url.saveValue();
  this.storedIndeterminate = this.indeterminate;
};

/**
 * Any render action that needs to happen outside text fields
 */
yext.location.NamedUrl.prototype.render = function() {
  this.$checkbox.prop('indeterminate', this.indeterminate);
};

/**
 * Get the plain version of this field's data
 *
 * @return {!Object}
 */
yext.location.NamedUrl.prototype.data = function() {
  return {
    'url': this.url.coreData(),
    'nameTextView': this.name.coreData(),
    'indeterminate': this.indeterminate,
    'timestamp': this.timestamp,
  };
};

/**
 * Sets a hidden input to the value of the field as JSON
 */
yext.location.NamedUrl.prototype.setFieldValue = function() {
  this.$fieldValue.val(window.JSON.stringify(this.data()));
};

/**
 * Restore the state of the url to a stored value
 */
yext.location.NamedUrl.prototype.reset = function() {
  this.url.reset();
  this.name.reset();
  if (this.charCounter) {
    this.charCounter.update();
  }
  this.indeterminate = this.storedIndeterminate;
  this.render();
};

/**
 * Updates the field to the state provided
 *
 * @param {!Object} POJO version of this field
 */
yext.location.NamedUrl.prototype.set = function(data) {
  this.url.set(data['url']);
  this.name.set(data['nameTextView']);
  this.indeterminate = data['indeterminate'];
  this.timestamp = data['timestamp'];
  this.render();
};
